import script from "./LobbyLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./LobbyLayout.vue?vue&type=script&setup=true&lang=ts"

import "./LobbyLayout.vue?vue&type=style&index=0&id=62ee59fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ee59fa"]])

export default __exports__